// import React from 'react';
// import { Bar } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import moment from 'moment';

// // Register the required components and scales
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// );

// const LineChart = ({
//   combinedKeys = [],
//   firstLineData = [],
//   secondLineData = [],
//   firstHeading = '',
//   secondHeading = '',
// }) => {
//   const formatDateStrings = (dateStrings) => {
//     const formattedDates = dateStrings.map((dateString) => {
//       const formattedDate = moment(dateString, 'YYYY-MM-DD').format(
//         'D MMM, YYYY',
//       );
//       return formattedDate;
//     });

//     return formattedDates;
//   };
//   const formattedDates = formatDateStrings(combinedKeys);

//   const data = {
//     // labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
//     labels: [...formattedDates],
//     datasets: [
//       {
//         label: firstHeading,
//         data: [...firstLineData],
//         fill: false,
//         borderWidth: 1,
//         barThickness: 30,
//         borderColor: '#994DFD',
//         backgroundColor: '#994DFD',
//       },
//       {
//         label: secondHeading,
//         data: [...secondLineData],
//         fill: false,
//         borderWidth: 1,
//         barThickness: 30,
//         borderColor: 'rgba(21, 166, 248, 1)',
//         backgroundColor: 'rgba(21, 166, 248, 1)',
//       },
//     ],
//   };
//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: true,
//         // position: 'top',
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: (value) => {
//             return Number.isInteger(value) ? value : '';
//           }, // Only display integers
//         },
//       },
//     },
//     type: 'bar',
//   };

//   return <Bar className="lineChart" data={data} options={options} />;
// };

// export default LineChart;

import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const LineChart = ({
  combinedKeys,
  firstLineData,
  secondLineData,
  firstHeading,
  secondHeading,
  hideSecondLine = false,
  hideCheckboxes = false,
}) => {
  const [showFirstLine, setShowFirstLine] = useState(true);
  const [showSecondLine, setShowSecondLine] = useState(true);
  const canShowSecondLine = !hideSecondLine && secondHeading;

  const data = {
    labels: combinedKeys,
    datasets: [
      ...(showFirstLine
        ? [
            {
              label: firstHeading,
              data: firstLineData,
              borderColor: '#8B5CF6',
              backgroundColor: 'rgba(139, 92, 246, 0.1)',
              tension: 0.4,
              fill: true,
              pointRadius: 4,
              pointHoverRadius: 6,
            },
          ]
        : []),
      ...(canShowSecondLine && showSecondLine
        ? [
            {
              label: secondHeading,
              data: secondLineData,
              borderColor: '#06B6D4',
              backgroundColor: 'rgba(6, 182, 212, 0.1)',
              tension: 0.4,
              fill: true,
              pointRadius: 4,
              pointHoverRadius: 6,
            },
          ]
        : []),
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Legend ko hide kar diya kyunki custom checkboxes use kar rahe hain
      },
      tooltip: {
        callbacks: {
          label(context) {
            return `${context.dataset.label}: ${context.parsed.y}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div style={{ width: '100%' }}>
      {/* Checkboxes */}
      {!hideSecondLine && !hideCheckboxes && (
        <div
          style={{
            display: 'flex',
            gap: '20px',
            marginBottom: '15px',
            justifyContent: 'flex-end',
            paddingRight: '20px',
          }}
        >
          <label
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              userSelect: 'none',
            }}
          >
            <input
              type="checkbox"
              checked={showFirstLine}
              onChange={(e) => setShowFirstLine(e.target.checked)}
              style={{ cursor: 'pointer', width: '16px', height: '16px' }}
            />
            {firstHeading}
          </label>

          {secondHeading && (
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                userSelect: 'none',
              }}
            >
              <input
                type="checkbox"
                checked={showSecondLine}
                onChange={(e) => setShowSecondLine(e.target.checked)}
                style={{ cursor: 'pointer', width: '16px', height: '16px' }}
              />
              <span>{secondHeading}</span>
            </label>
          )}
        </div>
      )}

      {/* Chart */}
      <div style={{ height: '301px', width: '100%' }}>
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default LineChart;
